import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IAddTemplateReq, IAddTemplateRes } from './index.type';

const useAddTemplate = ({templateId }: { templateId:string }) => {
  const url =  !templateId ? `/rtm/template` : `/rtm/template/${templateId}`;
  const method = !templateId ? 'POST' : 'PUT';

  const { loading: addTemplateLoading, makeApiCall } = useApi({ url, method });

  const addTemplate = async (formData: IAddTemplateReq) => {
    const { response, error } = await makeApiCall<IAddTemplateReq, IAddTemplateRes>(formData);
    
    if (response?.status) {
      toast.success(!templateId ? 'Template added successfully' : 'Template updated successfully'); 
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to save template. Please check your input and try again.');
      return { status: false };
    }
  };

  return {
    addTemplateLoading,
    addTemplate,
  };
};

export default useAddTemplate;
